export default __webpack_public_path__ + "static/media/banner9.c9f73b43.png";